<template>
  <v-chip
    v-if="value !== undefined"
    label
    :color="color"
    class="justify-center pa-0"
    style="width: 32px"
  >
    {{ value }}
  </v-chip>
  <div
    v-else
    class="grey--text caption"
  >
    N/A
  </div>
</template>

<script>
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'TableSelectionChipValue',
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    max: {
      type: Number,
      required: true
    },
    reverseColors: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    color() {
      return getColorForValue(this.value, this.max, this.reverseColors)
    }
  }
}
</script>

<style scoped>

</style>
